import { render, staticRenderFns } from "./DeviceMonitorTemplateItems.vue?vue&type=template&id=0fd74680&scoped=true"
import script from "./DeviceMonitorTemplateItems.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorTemplateItems.vue?vue&type=script&lang=js"
import style0 from "./DeviceMonitorTemplateItems.vue?vue&type=style&index=0&id=0fd74680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd74680",
  null
  
)

export default component.exports